<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import WhatsappRecontactForm from './WhatsappRecontactForm.vue';

defineProps({
  timeZone: { type: String, default: 'UTC' },
  templates: { type: Array, default: () => [] },
  schedule: { type: Object, default: null },
  isSaving: { type: Boolean, default: false },
});

const emit = defineEmits(['save']);
const { t } = useI18n();
const dialogRef = ref(null);
const formRef = ref(null);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    width="3xl"
    overflow-y-auto
    :title="
      schedule
        ? t('INBOX_MGMT.RECONTACT.EDIT_TITLE')
        : t('INBOX_MGMT.RECONTACT.ADD')
    "
    @confirm="formRef?.submit()"
  >
    <div class="flex max-h-[65vh] flex-col overflow-y-auto pe-1">
      <WhatsappRecontactForm
        ref="formRef"
        :time-zone="timeZone"
        :templates="templates"
        :schedule="schedule"
        @submit="payload => emit('save', payload)"
      />
    </div>
    <template #footer>
      <div class="flex w-full flex-col gap-3">
        <p v-if="formRef?.errorMessage" class="mb-0 text-sm text-n-ruby-9">
          {{ formRef.errorMessage }}
        </p>
        <div class="flex w-full items-center justify-between gap-3">
          <Button
            type="button"
            variant="faded"
            color="slate"
            class="w-full"
            :label="t('INBOX_MGMT.RECONTACT.FORM.CANCEL')"
            :disabled="isSaving"
            @click="close"
          />
          <Button
            type="submit"
            class="w-full"
            :label="t('INBOX_MGMT.RECONTACT.FORM.SAVE')"
            :is-loading="isSaving"
            :disabled="isSaving"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>
